import React, { useState } from "react";
import "./Support.scss";
//assets
import icon_message__sent from "../../assets/icons/icon-message--sent.svg";
import axios from "axios";
export default function Support(props) {
	const [ifMessageSent, setIfMessageSent] = useState(false);
	const [text, setText] = useState("");
	const userAuthenticated = JSON.parse(localStorage.getItem("user"));
	const sendMail = async (e) => {
		try {
			await axios.post("/sendSupportMail", {
				name: userAuthenticated.firstName + " " + userAuthenticated.lastName,
				email: userAuthenticated.email,
				text: text,
			});
			setIfMessageSent(!ifMessageSent);
			//console.log(res.data)
		} catch (error) {
			console.log(error);
		}
	};
	return (
		<div className="container container--main container--limited_width">
			<form className="support__form container--default px-3 py-4 px-md-4 py-md-5 position-relative">
				<h1 className="container__title">Need help?</h1>
				<p className="mt-2 mt-md-3">
					If you experiencing any problems using KodjoAcademy please fill the form below and we will contact you within
					2 days to solve your problem.
				</p>
				<textarea
					name="text"
					id=""
					cols="30"
					rows="10"
					placeholder="Tell us what happened..."
					className="input input--primary mt-4"
					onChange={(e) => setText(e.target.value)}
				></textarea>
				<div className="d-flex justify-content-center mt-5">
					<button type="button" onClick={sendMail} className="btn btn--primary w-100">
						Send
					</button>
				</div>
				{ifMessageSent && (
					<div className="support__form--message d-flex flex-column align-items-center justify-content-center text-center container--default px-3 py-4 px-md-4 py-md-5">
						<img src={icon_message__sent} alt="Message sent icon" className="mx-auto" />
						<h2 className="container__title mt-2 mt-md-3">Your message is sent</h2>
						<p className="mt-2 mt-md-3">
							We will answer you to your email <br /> <span className="fw--600">{userAuthenticated.email}</span>
						</p>
						<button
							className="btn btn--primary_light w-100 mt-5"
							onClick={() => {
								setIfMessageSent(!ifMessageSent);
							}}
						>
							Send new message
						</button>
					</div>
				)}
			</form>
		</div>
	);
}
